import React from 'react';
import { usePrevious } from '../../../hooks/usePrevious';

export type UseCurrentAndPreviousTabArgs = {
    selectedTab: string;
    onTabChange: () => void;
};

export type UseCurrentAndPreviousTabReturnValue = {
    selectedTab: string;
    previousTab: string | null;
};

export const useCurrentAndPreviousTab = ({
    selectedTab,
    onTabChange,
}: UseCurrentAndPreviousTabArgs): UseCurrentAndPreviousTabReturnValue => {
    const previousTab = usePrevious(selectedTab, onTabChange);
    return { selectedTab, previousTab };
};

export const IsInSideTabContentContainerContext = React.createContext<boolean>(false);

export const useIsInSideTabContentContainer = (): boolean => React.useContext(IsInSideTabContentContainerContext);
